import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useStyles } from '../../adminStyles';
import { Container } from '@material-ui/core';
import { getProjectList } from '../../../../redux/projects/projectsActions';

import ProjectRecord from './ProjectRecord';

const ProjectDetails = props => {
  document.title = 'Sciata Projects';

  const dispatch = useDispatch();
  const projectList = useSelector(state => state.projects.allProjects);
  const { container } = useStyles();
  const [selectedProject, setSelectedProject] = useState({});
  const [projectId, setProjectId] = useState(+props.match.params.pid);

  useEffect(() => {
    const getProjects = () => dispatch(getProjectList());
    const getProject = () => {
      if (projectList.length) {
        let project = projectList.find(project => project.projectId === projectId);
        setSelectedProject(project || {});
        return;
      }
      setSelectedProject({});
    };
    getProjects();
    getProject();
  }, []);

  return (
    <Container className={container}>
      <h1>{projectId > 0 ? 'Edit Project' : 'Add Project'}</h1>
      <ProjectRecord project={selectedProject} />
    </Container>
  );
};

export default withRouter(ProjectDetails);
